//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import * as d3 from "d3";

import axios, { CancelToken } from "axios";
import { GChart } from "vue-google-charts";
export default {
  components: {
    GChart,
  },
  props: {
    chartData: Array,
    chartTitle: String,
    grp: String,
    loc: String,
    process: String,
  },
  data() {
    return {
      period: "",
      chartOptions: {
        backgroundColor: {
          fill: "#ffffff",
          fillOpacity: 0.5,
        },
        title: "",
        fontSize: 12,
        fontName: "Roboto Condensed",
        color: "#ffffff",
        // textStyle: {
        //   fontName: 'Open Sans',
        //   bold: true,
        //   italic: true,
        //   fontSize: 18,
        //   color: '#ffffff',
        // },
        legend: {
          position: "top",
        },
        bar: {
          groupWidth: "50%",
        },
        hAxis: {
          format: "decimal",
        },
        vAxis: {
          // title: '% OTP',
          minValue: 0,
          // maxValue: 100,
          gridlines: {
            count: 0,
          },
        },
        animation: {
          duration: 1200,
          easing: "out",
          startup: true,
        },
        chartArea: {
          backgroundColor: {
            fill: "#99ddff",
            fillOpacity: 0.1,
            // 'opacity': 100
          },
          // left: 50,
          top: 20,
          bottom: 30,
          // right: 85,
          // width: '400px',
          // height: '200%'
        },
        colors: ["#ffffff", "#76D7C4"],
        seriesType: "bars",
        series: {
          1: {
            type: "line",
          },
        },
        annotations: {
          alwaysOutside: true,
          textStyle: {
            fontSize: 12,
            color: "#000",
            bold: true,
          },
          // boxStyle: {
          //   stroke: "#ccc",
          //   strokeWidth: 1,
          //   rx: 0,
          //   ry: 0,
          //   gradient: {
          //     color1: "#f3e5f5",
          //     color2: "#f3e5f5",
          //     x1: "0%",
          //     y1: "0%",
          //     x2: "100%",
          //     y2: "100%",
          //     useObjectBoundingBoxUnits: false,
          //   },
          // },
          datum: {
            stem: {
              color: "none",
              length: 6,
            },
          },
          // domain: {
          //   stem: {
          //     color: "red",
          //     length: 6,
          //     style:"point"
          //   },
          // },
          highContrast: false,
        },
      },
      chartEvents: {
        select: () => {
          const table = this.$refs.gChart.chartObject;
          const selection = table.getSelection();
          const onSelectionMeaasge =
            selection.length !== 0 ? "row was selected" : "row was diselected";
          // console.log(selection);
        },
      },
    };
  },
  async mounted() {
    // this.chartOptions.title = this.chartTitle;
  },
  methods: {
    exportdetail() {
      if (this.process == "FAB") {
        window.open(
          `${this.$apiflask}otpdetail_fabric/${this.grp}/${this.loc}/${
            this.period
          }/${this.create_UUID()}`,
          "_export"
        );
      } else if (this.process == "SEW") {
        window.open(
          `${this.$apiflask}otpdetail_sew/${this.grp}/${this.loc}/${
            this.period
          }/${this.create_UUID()}`,
          "_export"
        );
      } else if (this.process == "PACK") {
        window.open(
          `${this.$apiflask}otpdetail_pack/${this.grp}/${this.loc}/${
            this.period
          }/${this.create_UUID()}`,
          "_export"
        );
      }
    },
  },
};
